












import Vue from 'vue';
import { mapState } from 'vuex';
import { AppScope } from '../../constants/appScope';
import ThePageMenu from '@/components/common/public/ThePageMenu.vue';

export default Vue.extend({
  name: 'TheLayout',
  components: {
    ThePageMenu,
  },
  computed: {
    isDashboard(): boolean {
      const scope = this.getScope();
      return scope === AppScope.Dashboard;
    },
    ...mapState({
      landingUrl: (state: any): string => state.dashboard.settings.landing_url,
      hotel(state: any) {
        return this.isDashboard ? state.dashboard.hotel : state.landing.hotel.item;
      },
    }),
  },
});
